import { render, staticRenderFns } from "./scoring-console.vue?vue&type=template&id=779278d6&scoped=true&"
import script from "./scoring-console.vue?vue&type=script&lang=js&"
export * from "./scoring-console.vue?vue&type=script&lang=js&"
import style0 from "./scoring-console.vue?vue&type=style&index=0&id=779278d6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779278d6",
  null
  
)

export default component.exports